var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
let InstructionsComponent = class InstructionsComponent extends LitElement {
    render() {
        return html `
            <div class="instructions">
                <p><b>Echos of Players Past</b></p>
                <p>
                    At the start of each level, you can summon one or more players to help you
                    complete the level. These are real players who have previously played the game.
                </p>
                <p>
                    Only 1 player needs to make it to the goal in order for you to beat the level.
                    Whenever you beat a level, your movement will be saved, and future players will
                    be able to summon you!
                </p>
                <p>Controls:</p>
                <ul>
                    <li>Arrow keys to move</li>
                    <li>R to restart the level</li>
                </ul>
            </div>
            <character-customizer></character-customizer>
        `;
    }
};
InstructionsComponent.styles = css `
        :host {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        character-customizer {
            position: absolute;
            top: 0;
            left: 50%;
            right: 0;
            bottom: 0;
        }

        .instructions {
            position: absolute;
            top: 0;
            left: 0;
            right: 50%;
            bottom: 0;

            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 30px;
            font-size: 1.5em;
        }

        p, li {
            line-height: 1.6em;
        }
    `;
InstructionsComponent = __decorate([
    customElement('instructions-component')
], InstructionsComponent);
export { InstructionsComponent };
